import { PureComponent } from 'react';

import { isNonNullable } from '@ipfabric/utils';
import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import OverviewPropTypes from '../../OverviewPropTypes';
import WidgetOptions from './WidgetOptions';

export default class TextRowForm extends PureComponent {
  static propTypes = {
    editWidget: OverviewPropTypes.editWidget,
    msg: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    textRow: OverviewPropTypes.textRow,
    widgetName: PropTypes.string.isRequired,
    widgetProps: OverviewPropTypes.widgetProps,
  };

  handleSubmit = (values) => {
    const { onSubmit, widgetName } = this.props;
    onSubmit(values.toJS(), widgetName, 'widget');
  };

  render() {
    const { editWidget, msg, onClose, textRow, widgetProps } = this.props;
    return (
      <div>
        <WidgetOptions
          editWidget={editWidget}
          msg={msg}
          initialValues={
            new ImmutableMap(
              isNonNullable(widgetProps) ? widgetProps : { variables: '' },
            )
          }
          onClose={onClose}
          onSubmit={this.handleSubmit}
          textRow={textRow}
        />
      </div>
    );
  }
}
